/**
 * * Модель фильтра канбана
 */
export class TasksKanbanFilterModel {
  /**Строка поиска */
  Search: string = "";
  /**Показывать вложенные задачи */
  ShowNestedTasks: boolean = false;

  constructor(obj?: Partial<TasksKanbanFilterModel>) {
    Object.assign(this, obj);
  }
}
